import { component_tool } from '../../../tool';
let { WizModal } = component_tool;

//配置项
let componentName = 'role'

const columns = [
  {
    name: "id",
    formItem: {
      type: "hidden"
    }
  },
  {
    title: "角色名称",
    name: "name",
    dataIndex: "name",
    formItem: {
      maxlength: 50,
      placeholder: '请输入角色名称,最多输入50个字符',
      rules: [{
        required: true,
        message: '请输入角色名称',
      },
      {
        pattern: /^[A-Za-z\d_\-\u4e00-\u9fa5]{1,50}$/,
        message: '角色名称不允许使用特殊符号'
      }
    ]
    },
    searchItem: {},
    tableItem: {}
  },
  {
    title: "角色编码",
    name: "code",
    dataIndex: "code",
    formItem: {
      maxlength: 64,
      placeholder: '请输入角色编码,最多输入64个字符',
      rules: [{
        required: true,
        message: '请输入角色编码',
      }]
    },
    searchItem: {},
    tableItem: {}
  },
  {
    title: "角色描述",
    name: "remark",
    dataIndex: "remark",
    formItem: {
      maxlength: 100,
      type: 'textarea',
      rows:5,
      placeholder: '请输入角色描述,最多输入100个字符',

    },
    tableItem: {
    }
  }
];

const templateConfig = {
  mainProps: {},
  content: {
    name: "WizTableList",
    params: {
      columns,
      searchBarProps: {
        collapse:false,
        cols: {
          xs: 24,
          md: 12,
          xl: 8
      },
      buttonSort:['add',"delete",'export'],
      buttons: [
        {
          key: 'export',
          custom: true,
          params: { icon: 'export', children: '导出', type: 'export'},
          customOnClick: {
            key: 'action',
            params: {
              apiKey: "export",
              apiParams: {}
            },
            formatParams:(rows,record,filters,callback)=>{
              return {...filters}
            }
          }
        }
      ]
      },

      modalFormProps: {},
      dataTableProps: {
        rowKey: "id",
        selectType: "checkbox",
        isScroll: true,
        loading: false
      },
      rowOperateSort:['update','personnelManagement','authorityManagement'],
      rowOperateView: [
      {
        key: "personnelManagement",
            custom: true,
            params: { children: "人员管理"},
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname:"/auth/roleList/roleUserList"
              },
            }
    },
  //   {
  //     key: "modal",
  //         custom: true,
  //         params: { children: "用户组维护"},
  //         customOnClick: {
  //           key: "jumpPage",
  //           params: {
  //             key: "push",
  //             pathname:"/auth/roleList/roleGroupList"
  //           },
  //         }
  // },

    {
      key: "authorityManagement",
      custom: true,
      params: {children: "权限管理"},
      customOnClick: {
        key: "jumpPage",
        params: {
          key: "push",
          pathname:"/auth/roleList/roleManager"
        },
      }
  },

      ],
      commonOperate: {
        add: true,
        delete: true,
        update: true

    }
    }
  }
};

const apis = {
  list: {
    path: `${componentName}/getListByPage`,
    payload: {
      key: `${componentName}@listByPage`,
      apiParams: { pageNum: 1, pageSize: 10 }
    }
  },
  add: {
    path: `${componentName}/add`,
    payload: {
      key: `${componentName}@add`,
      apiParams: {}
    }
  },
  update: {
    path: `${componentName}/update`,
    payload: {
      key: `${componentName}@update`,
      apiParams: {}
    }
  },
  delete: {
    path: `${componentName}/delete`,
    payload: {
      key: `${componentName}@delete`,
      apiParams: {}
    }
  },
  export: {
    path: `${componentName}/export`,
    payload: {
      key: `${componentName}@export`,
      apiParams: {}
    }
  }

}


let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
};

export { reduxTemplateCofig, templateConfig };
